(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["book-a-fitting"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.currentScript.closest('.bf-wrap') || document;

    // ---- File inputs: previews + remove ----
    root.querySelectorAll('[data-bf-file-drop]').forEach(function (drop) {
      var input = drop.querySelector('[data-bf-file-input]');
      var previewWrap = drop.parentElement.querySelector('[data-bf-file-previews]');
      var dt; // DataTransfer to manage the file list manually

      function render() {
        previewWrap.innerHTML = '';
        dt = new DataTransfer();
        Array.from(input.files || []).forEach(function (file, i) {
          dt.items.add(file);
          if (!file.type.startsWith('image/')) return;
          var reader = new FileReader();
          reader.onload = function (e) {
            var box = document.createElement('div');
            box.className = 'bf-preview';
            box.innerHTML = '<img src="' + e.target.result + '" alt="' + (file.name || 'photo') + '"><button type="button" aria-label="Remove photo">×</button>';
            box.querySelector('button').addEventListener('click', function () {
              var files = Array.from(input.files);
              files.splice(i, 1);
              var newDt = new DataTransfer();
              files.forEach(function (f) { newDt.items.add(f); });
              input.files = newDt.files;
              render();
            });
            previewWrap.appendChild(box);
          };
          reader.readAsDataURL(file);
        });
      }

      input.addEventListener('change', render);
    });

    // ---- Submit: basic validation + loading state + optional custom endpoint ----
    var form = root.querySelector('.bf-form');
    if (!form) return;

    var endpointInput = form.querySelector('.bf-endpoint');
    if (endpointInput && endpointInput.value) {
      form.setAttribute('action', endpointInput.value);
      form.setAttribute('enctype', 'multipart/form-data');
    }

    form.addEventListener('submit', function (e) {
      var invalid = form.querySelector(':invalid');
      if (invalid) {
        e.preventDefault();
        invalid.focus();
        invalid.reportValidity();
        return;
      }
      var btn = form.querySelector('.bf-btn');
      if (btn) {
        btn.classList.add('loading');
        btn.setAttribute('disabled', 'disabled');
      }
    });

    // Show success banner if redirected back from a custom endpoint (e.g. Formspree "_redirect")
    if (window.location.search.indexOf('fitting_submitted=true') !== -1 && !root.querySelector('.bf-banner.success')) {
      var banner = document.createElement('div');
      banner.className = 'bf-banner success';
      banner.setAttribute('role', 'status');
      banner.innerHTML = '<strong>Request received!</strong><br>Thanks — our team will be in touch shortly to confirm your fitting.';
      form.parentNode.insertBefore(banner, form);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
